import axiosInstance from "@/api/axiosInstance";
import { ListPaymentRequestsQuery, ListPaymentRequestsResponse } from "./types";

export async function listPaymentRequests(
  query: ListPaymentRequestsQuery = {},
): Promise<ListPaymentRequestsResponse> {
  const response = await axiosInstance.get(`/api/private/payment-requests`, {
    params: query,
  });
  return response.data?.data ?? response.data;
}
